import { BASE_PATH, PATH_BASE_EXTENSION_USER } from "../../utils/constants";
import { authFetch } from "../../utils/fetch";
import {getToken} from "../Auth/token";
import axios from "axios";

export async function getUserApi(data) {
    const url = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/user/get-user`;
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(url, data ,config)

}

export async function setObservacionUserApi(data) {
    
        const url = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/user/update-observacion`;
        const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
        return axios.post(url, data ,config)
}





